// import React from "react";
// import { FaCalendarAlt } from "react-icons/fa";
// import { FaClock, FaLocationDot } from "react-icons/fa6";
// import { useNavigate } from "react-router-dom";

// const TripCard = ({ trip, showLocationInCard = false }) => {
//     const navigate = useNavigate();

//     // Extract trip data with fallbacks
//     const {
//         id,
//         location,
//         title,
//         thumbnail_image,
//         slug,
//         pickuploaction,
//         duration_day,
//         duration_night,
//         short_description,
//         trips_category,
//         latest_batch,

//     } = trip;

//     const handleCardClick = () => {
//         if (slug) {
//             navigate(`/tripsdetails/${slug}`);
//         }
//     };

//     return (
//         <div
//             className="col-md-5 col-lg-3 col-xl-3 custom-all-trips-states-card rounded-3 overflow-hidden px-0 mx-2 my-2"
//             style={{ border: "2px solid #b0cfd0", cursor: "pointer" }}
//             onClick={handleCardClick}
//         >
//             {/* Trip Image */}
//             <div className="custom-all-trips-card-img">
//                 <img
//                     src={thumbnail_image}
//                     alt={title}
//                     className="img-fluid"
//                     loading="lazy"
//                 />
//             </div>

//             {/* Category Badge */}
//             {trips_category && (
//                 <div className="custom-all-trips-badge">
//                     {trips_category}
//                 </div>
//             )}

//             {/* Card Body */}
//             <div className="custom-all-trips-card-body">
//                 <div className="custom-all-trips-card-content">
//                     {/* Title */}
//                     <h5>{title}</h5>

//                     {/* Duration and Location Row */}
//                     <div className="container-fluid">
//                         <div className="row">
//                             {/* Duration */}
//                             <div className="col-6 text-start ps-3 pb-1 custom-trip-card-icons-cont">
//                                 <FaClock
//                                     className="fs-5 me-2 custom-trip-card-icons"
//                                     style={{ color: "#f36d21" }}
//                                 />
//                                 <span style={{ fontSize: "0.85rem" }}>
//                                     {duration_day}D/
//                                 </span>
//                                 <span style={{ fontSize: "0.85rem" }}>
//                                     {duration_night}N
//                                 </span>
//                             </div>

//                             {/* Location */}
//                             <div className="col-6 text-end ps-2 pe-4 pb-1 custom-trip-card-icons-cont d-flex align-items-center">
//                                 <FaLocationDot
//                                     className="fs-5 me-2 custom-trip-card-icons"
//                                     style={{ color: "#f36d21" }}
//                                 />
//                                 <span
//                                     style={{
//                                         fontSize: "0.85rem",
//                                         whiteSpace: "nowrap",
//                                         overflow: "hidden",
//                                         textOverflow: "ellipsis",
//                                         display: "inline-block",
//                                         maxWidth: "120px",
//                                     }}
//                                 >
//                                     {/* Show pickuploaction unless showLocationInCard is true and title should be shown */}
//                                     {pickuploaction}
//                                 </span>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Description */}
//                     {/* <div
//                         className="custom-all-trips-date-choice px-3"
//                         style={{
//                             fontSize: "0.85rem",
//                             display: "-webkit-box",
//                             WebkitLineClamp: 2,
//                             WebkitBoxOrient: "vertical",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             textAlign: "start",
//                         }}
//                         dangerouslySetInnerHTML={{ __html: short_description }}
//                     /> */}
//                     <div className="custom-trip-card-date">
//                         <span><FaCalendarAlt className="fs-5 me-2 custom-trip-card-icons"
//                             style={{ color: "#f36d21" }} /></span><span>{latest_batch
//                             }</span>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default TripCard;


// TODO : :LAST CODE WITH NO CHANGE 100% CORREC
import React from "react";
import { FaCalendarAlt } from "react-icons/fa";
import { FaClock, FaLocationDot } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

// Helper function to format the date
const formatDate = (dateString) => {
    if (!dateString) return "";

    // Create a Date object from the date string
    const date = new Date(dateString);

    // Check if the date object is valid
    if (isNaN(date.getTime())) {
        console.error("Invalid date string provided to formatDate:", dateString);
        return dateString; // Return the original string if parsing fails
    }

    // Get the day (date) and month abbreviation
    const day = date.getDate();
    // Use toLocaleString for month abbreviation, 'short' gives 'Oct', 'long' gives 'October'
    // 'en-US' locale is used for standard English month abbreviations
    const month = date.toLocaleString('en-US', { month: 'short' });

    // Format as "27-Oct"
    return `${day}-${month}`;
};

const TripCard = ({ trip, selectedDate, showLocationInCard = false }) => {
    const navigate = useNavigate();

    // Extract trip data with fallbacks
    const {
        id,
        location,
        title,
        thumbnail_image,
        slug,
        pickuploaction,
        duration_day,
        duration_night,
        short_description,
        trips_category,
        latest_batch,
        batches,
    } = trip;

    // console.log(batches);

    // const formattedDate = formatDate(latest_batch);

    const batche_from = batches && batches.length > 0 ? batches[0]?.batche_from : null;
    const formattedDate = formatDate(selectedDate || batche_from);

    const handleCardClick = () => {
        if (slug) {
            navigate(`/tripsdetails/${slug}`);
        }
    };

    return (
        <div
            className="col-md-5 col-lg-3 col-xl-3 custom-all-trips-states-card rounded-3 overflow-hidden px-0 me-2 my-2"
            style={{ border: "2px solid #b0cfd0", cursor: "pointer" }}
            onClick={handleCardClick}
        >
            {/* Trip Image */}
            <div className="custom-all-trips-card-img">
                <img
                    src={thumbnail_image}
                    alt={title}
                    className="img-fluid"
                    loading="lazy"
                />
            </div>

            {/* Category Badge */}
            {trips_category && (
                <div className="custom-all-trips-badge">
                    {trips_category}
                </div>
            )}

            {/* Card Body */}
            <div className="custom-all-trips-card-body">
                <div className="custom-all-trips-card-content">
                    {/* Title */}
                    <h5>{title}</h5>

                    {/* Duration and Location Row */}
                    <div className="container-fluid">
                        <div className="row">
                            {/* Duration */}
                            <div className="col-6 text-start ps-3 pb-1 custom-trip-card-icons-cont">
                                <FaClock
                                    className="fs-5 me-2 custom-trip-card-icons"
                                    style={{ color: "#f36d21" }}
                                />
                                <span style={{ fontSize: "0.85rem" }}>
                                    {duration_day}D/
                                </span>
                                <span style={{ fontSize: "0.85rem" }}>
                                    {duration_night}N
                                </span>
                            </div>

                            {/* Location */}
                            <div className="col-6 text-start ps-3 pb-1 custom-trip-card-icons-cont">
                                <FaLocationDot
                                    className="fs-5 me-2 custom-trip-card-icons"
                                    style={{ color: "#f36d21" }}
                                />
                                <span style={{ fontSize: "0.85rem" }}>
                                    {/* Show pickuploaction unless showLocationInCard is true and title should be shown */}
                                    {pickuploaction}
                                </span>
                            </div>
                        </div>

                        {formattedDate && (
                            <div className="row mt-1">
                                {/* Duration */}
                                <div className="col-6 text-start ps-3 pb-1 custom-trip-card-icons-cont">
                                    <FaCalendarAlt
                                        className="fs-5 me-2 custom-trip-card-icons"
                                        style={{ color: "#f36d21" }}
                                    />
                                    <span style={{ fontSize: "0.85rem" }}>
                                        {/* Use the formatted date here */}
                                        {formattedDate}
                                    </span>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </div>
    );
};

export default TripCard;
